import { createContext, useContext } from 'react';

import type { BlueprintPage } from '../types';

/**
 * The sheet list the container built, so the shared header/footer can resolve their own
 * sheet's `overrideScope` and `legacyPageNumber` from the pageNumber they already receive —
 * rather than every page component threading two more props into both of them.
 */
export const BlueprintPagesContext = createContext<Array<BlueprintPage>>([]);

export const usePageByNumber = (pageNumber: number): BlueprintPage | null => {
	const pages = useContext(BlueprintPagesContext);
	return pages.find((page) => page.pageNumber === pageNumber) ?? null;
};
